import { ReactNode } from 'react';

export interface EntityDetailTabCustomizationItem {
    description: ReactNode;
    icon: ReactNode;
    key: string;
    label: ReactNode;
    locked?: boolean;
}

export interface EntityDetailResourceTypeOption {
    description: ReactNode;
    disabled?: boolean;
    icon: ReactNode;
    label: ReactNode;
    value: string;
}

export interface EntityDetailTabPreferences {
    hidden?: string[];
    order?: string[];
}

export const getEntityDetailTabPreferences = (
    preferences: unknown,
    resourceType: string,
): EntityDetailTabPreferences => {
    const value = preferences as
        | {
              entityDetail?: {
                  tabs?: Record<string, EntityDetailTabPreferences>;
              };
          }
        | null
        | undefined;

    return value?.entityDetail?.tabs?.[resourceType] ?? {};
};

export const orderEntityDetailTabItems = <T extends { key: string }>(
    items: T[],
    preferences?: EntityDetailTabPreferences,
): T[] => {
    const itemByKey = new Map(items.map((item) => [item.key, item] as const));
    const savedOrder = Array.from(new Set((preferences?.order ?? []).filter((key) => itemByKey.has(key))));
    const nextOrder = [...savedOrder, ...items.map((item) => item.key).filter((key) => !savedOrder.includes(key))];

    return nextOrder.map((key) => itemByKey.get(key)).filter((item): item is T => item !== undefined);
};

export const visibleEntityDetailTabItems = <T extends { key: string; locked?: boolean }>(
    items: T[],
    preferences?: EntityDetailTabPreferences,
): T[] => {
    const hidden = new Set(preferences?.hidden ?? []);

    return orderEntityDetailTabItems(items, preferences).filter((item) => item.locked || !hidden.has(item.key));
};
